// extracted by mini-css-extract-plugin
export default {"actionList":"Order_actionList__WPKKl","link":"Order_link__e-p5G","button":"Order_button__A1kYz","payButton":"Order_payButton__N1TKF","payIcon":"Order_payIcon__if1I+"};